(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(leanProjectGeneralSavingsConfig);


	function leanProjectGeneralSavingsConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'generalProjectSavings', {
				name: 'Lean Projects by Area, Site, or Business Unit',
				description: 'Savings amounts or number of projects by stage, grouped by lean project area, site, or business unit.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/Number-of-Initiatives-by-Category.jpg',
				categories: ['All', 'Lean Projects'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'genericProjectSavingsCtrl',
				templateUrl: '/application/f/dashboard/widgets/lean-project-general-savings.html',
				reload: true,
				isDrillDown: false,
				isEditable: true,
				resolve: {
					title: function (config) {
						if (config.title) {
							return config.title;
						}
					},
					type: function (config) {
						if (config.type) {
							return config.type;
						}
					},
					viewType: function (config) {
						if (config.viewType) {
							return config.viewType;
						}
					},
					displayType: function (config) {
						if (config.displayType) {
							return config.displayType;
						}
					}
				}
			}
		);
	}
})();
